module.exports = __webpack_public_path__ + "static/img/gzhz-title.bb68838.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/xiayan/assets/img/gzhz-title.png
// module id = FNes
// module chunks = 1